import { Component, EventEmitter, Input, Output, TemplateRef, AfterViewInit, viewChild, signal, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { AuditLogEntry } from '../../../../services/audit-log/audit-log.model';
import { TableComponent, ColumnConfig, ColumnType, BadgeComponent } from 'htx-ui-library';

@Component({
  selector: 'app-audit-log-table',
  imports: [CommonModule, TranslocoPipe, TableComponent, BadgeComponent],
  templateUrl: './audit-log-table.component.html',
})
export class AuditLogTableComponent implements AfterViewInit {

  private translocoService = inject(TranslocoService);

  @Input() entries: AuditLogEntry[] = [];
  @Input() isDsa = false;
  @Output() selectEntry = new EventEmitter<AuditLogEntry>();

  outcomeTemplateRef = viewChild<TemplateRef<{ $implicit: AuditLogEntry }>>('outcomeTemplate');
  columnConfig = signal<ColumnConfig<AuditLogEntry>[]>([]);

  ngAfterViewInit(): void {
    const t = (key: string) => this.translocoService.translate(key);

    const cols: ColumnConfig<AuditLogEntry>[] = [
      {
        name: 'occurredAt',
        columnType: ColumnType.PLAIN,
        headerLabel: t('auditLog.column.occurredAt'),
        sortable: true,
        cellContent: (r) => new Date(r.occurredAt).toLocaleString('de-DE'),
      },
      {
        name: 'actorName',
        columnType: ColumnType.PLAIN,
        headerLabel: t('auditLog.column.actor'),
        cellContent: (r) => r.actorName ?? '—',
      },
      {
        name: 'action',
        columnType: ColumnType.PLAIN,
        headerLabel: t('auditLog.column.action'),
        cellContent: (r) => t(`auditLog.action.${r.action}`),
      },
      {
        name: 'resourceType',
        columnType: ColumnType.PLAIN,
        headerLabel: t('auditLog.column.resourceType'),
        cellContent: (r) => r.resourceType,
      },
      {
        name: 'outcome',
        columnType: ColumnType.TEMPLATE,
        headerLabel: t('auditLog.column.outcome'),
        template: this.outcomeTemplateRef(),
      },
    ];

    if (this.isDsa) {
      cols.push({
        name: 'tenantId',
        columnType: ColumnType.PLAIN,
        headerLabel: t('auditLog.column.tenant'),
        cellContent: (r) => r.tenantId ?? '—',
      });
    }

    this.columnConfig.set(cols);
  }

  onSelect(entry: AuditLogEntry): void {
    this.selectEntry.emit(entry);
  }
}
